export default __webpack_public_path__ + "static/bamford-7185d784fb2e4267513ca3621ae0c46a.jpg";